import { Flex, Text } from "@chakra-ui/react"

import CarNumberBox from "components/UI/molecules/CarNumberBox"
import { useReservationsContext } from "providers/ReservationsProvider/ReservationsProvider"
import { useUI } from "providers/UIProvider"

const ReservationDetailsCar: React.FC = () => {
  const { T } = useUI()
  const { currentReservation: reservation } = useReservationsContext()

  return (
    <Flex
      border="1px solid #E9F2FD"
      borderTop="unset"
      width="283px"
      height="120px"
      flexDirection="column"
      padding="14px 0 20px  24px"
    >
      <Text opacity={0.7} mb={"10px"} fontSize={"base"}>
        {T("booking.details.modal.auto")}
      </Text>
      <Text fontSize={"base"}>{reservation?.vehicleModel} ({reservation?.vehicleBodyType})</Text>
      <CarNumberBox height="40px" width="170px" title={reservation?.vehicleGovNumber} />
    </Flex>
  )
}

export default ReservationDetailsCar